import StoreContentPage from '../components/content/StoreContentPage';

export default function TermsConditions() {
  return (
    <StoreContentPage
      contentKey="terms"
      title="Terms & Conditions"
      fallback={
        <>
          <h1 className="font-display" style={{ margin: 0, fontSize: 'clamp(2rem,4vw,3.25rem)' }}>Terms & Conditions</h1>
          <p style={{ marginTop: '1rem', opacity: 0.78, lineHeight: 1.75 }}>
            By using this storefront, you agree to the terms governing orders, returns, payments, and account use.
            Product availability and pricing can change without notice. Orders may be canceled in cases of fraud risk,
            stock errors, or payment failure.
          </p>
          <p style={{ opacity: 0.78, lineHeight: 1.75 }}>
            Additional terms may apply to promotions, shipping zones, and region-specific offers displayed at checkout.
          </p>
        </>
      }
    />
  );
}
